module.exports = __webpack_public_path__ + "img/antes_despues_170.0f108e37.png";